import moment from 'moment';

import { MIN_ALLOWED_YEAR } from 'utils/constants/constants';

export const parseDate = (dateStr: string) => {
  const [day, month, year] = dateStr.split('.').map(Number);
  return new Date(year, month - 1, day);
};

export const sortDates = (v1: string, v2: string) => {
  const date1 = parseDate(v1);
  const date2 = parseDate(v2);
  // @ts-ignore
  return date1 - date2;
};

export const shouldDisableEndDate = (
  date: moment.MomentInput,
  startDate: moment.MomentInput | null
): boolean => {
  return moment(date).isBefore(moment(startDate));
};

export const shouldDisableStartDate = (
  date: moment.MomentInput,
  endDate: moment.MomentInput | null
): boolean => {
  return moment(date).isAfter(moment(endDate));
};

export const validateDateValue = (
  dateValue: Date | null,
  isFutureDateDisabled: boolean = true
): string => {
  if (!dateValue) return '';

  const date = moment(dateValue);

  if (!date.isValid()) {
    return 'errors.invalidDate';
  }

  if (isFutureDateDisabled && date.isAfter(moment(), 'day')) {
    return 'errors.invalidDate';
  }

  if (date.year() < MIN_ALLOWED_YEAR) {
    return 'errors.invalidYear';
  }

  return '';
};

export const validateDateRange = (
  fromDate: Date | null,
  toDate: Date | null
): string => {
  if (fromDate && toDate) {
    const isEndBeforeStart = moment(toDate).isBefore(moment(fromDate), 'day');
    if (isEndBeforeStart) {
      return 'errors.invalidDateRange';
    }
  }

  return '';
};
